export default {
  SET_TEST_SITE_STATUS: 'SET_TEST_SITE_STATUS',
};
